module.exports = __webpack_public_path__ + "img/header3.47fb397d.png";